<script lang="ts" setup>
// @ts-expect-error virtual file
import { NuxtLoadingIndicator } from '#components'
</script>

<template>
  <NuxtLoadingIndicator color="var(--primary)" error-color="var(--destructive)" :throttle="200" />
</template>
